import React, {PropTypes, Component} from 'react'
import Trash from 'react-icons/lib/md/delete'
import acc from 'accounting'

class ListSubjectItem extends Component {
  _onDelete = () => {
    this.props.onDelete(this.props.k)
  }

  render() {
    const {item, isShow} = this.props

    return (
      <tr>
        <td>
          {!isShow &&
            <button
              onClick={this._onDelete}
              type="button"
              className="btn-inline btn-icon"
            >
              <Trash />
            </button>}
        </td>
        <td>{item.get('subject_code')}</td>
        <td>{item.get('subject_name')}</td>
        <td><small>{item.get('curriculum_code')}</small></td>
        <td className="text-right">{acc.formatNumber(item.get('units'), 1)}</td>
        <td className="text-right">
          {acc.formatNumber(item.get('enrolled'), 0)}
        </td>
      </tr>
    )
  }
}

ListSubjectItem.propTypes = {
  k: PropTypes.number,
  item: PropTypes.object,
  isShow: PropTypes.bool,
}

export default ListSubjectItem



// WEBPACK FOOTER //
// ./src/containers/Setup/Offerings/list-subject-item.js